module.exports = __webpack_public_path__ + "static/george-81e5410878d953c697f14b5a18e0d04a.jpg";